import React  from 'react'
import { View, StyleSheet } from 'react-native'
import { Icon, Text, useTheme } from '@ui-kitten/components'
import { FontAwesome5 } from '@expo/vector-icons'
import { currencyFormatterAtom, storesDictAtom, usersDictAtom } from '../../global/AtomsProvider'
import { useAtomValue } from 'jotai'
import OperationsList from '../../components/OperationsList'
import { useTranslation } from 'react-i18next'

export default function SpendingsScreen({ navigation }) {
  const { t } = useTranslation()
  const theme = useTheme()
  const usersDict = useAtomValue(usersDictAtom)
  const currencyFormatter = useAtomValue(currencyFormatterAtom)
  const storesDict = useAtomValue(storesDictAtom)
  
  const renderItemFieldsToShow = (item, date) => {
    console.log('item', item)
    return (
      <>
        <View style={styles.dateTimeView}>
          <Icon name='file-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {item.category.text}
          </Text>
        </View>

        {item.details != null && item.details != '' && <View style={styles.dateTimeView}>
          <Icon name='more-horizontal-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {item.details}
          </Text>
        </View>}

        <View style={styles.dateTimeView}>
          <Icon name='credit-card-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {currencyFormatter.format(item.amount)}
          </Text>
        </View>
        
        <View style={styles.dateTimeView}>
          <Icon name='clock-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {date}
          </Text>
        </View>

        <View style={styles.dateTimeView}>
          <Icon name='person-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {usersDict?.[item.cashierUID]?.name}
          </Text>
        </View>

        <View style={styles.dateTimeView}>
          <FontAwesome5 name="building" size={16} color={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {storesDict?.[item.store]?.name || t('spendings.allStores')}
          </Text>
        </View>

      </>
    )
  }

  return (
    <View style={styles.container}>
      <OperationsList collectionName='spendings' dateField={'date'} additionalFilters={null} 
        detailScreenName={'SpendingDetail'} topView={() => {return null}} initialRange={null}
        showTotalSum={false} totalSumFormatter={currencyFormatter} totalSumField={'amount'}
        showAddButton={true} additionalDataValidation={() => {}} detailScreenParams={{isAdmin: true}}
        renderItemFieldsToShow={renderItemFieldsToShow} navigation={navigation} showStoreFilter={true}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },

  icon: {
    marginRight: 4,
  },
  itemTitle: {
    marginRight: 25,
  },
  dateTimeView: {
    flexDirection: 'row',
    alignItems: 'center'
  },
});
